var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"font-size":"18px","margin":"20px","padding-top":"40px","text-align":"left"}},[_vm._v(" 启航系统已升级小程序，请前往微信，扫码/搜索启航系统小程序使用系统~ ")]),_c('img',{staticStyle:{"max-width":"80%"},attrs:{"src":"https://elitebackground.oss-cn-zhangjiakou.aliyuncs.com/weapp.png"}})])
}]

export { render, staticRenderFns }